<template lang="pug">
    tr

        // Date created
        td {{ item.createdAt | formattedDate }}

        // Business Name
        td {{ item.name }}

        // Contact Name
        td(v-if="item.owner && item.owner.fullName") {{ item.owner.fullName }}
        td(v-else)

        // Program date (Start/End)
        td(v-if="item.program && item.program.startedAt") {{ item.program.startedAt | formattedDate }} - {{ item.program.endedAt | formattedDate }}
        td(v-else)

        // Status
        td
            status-component(v-if="item.isActive") {{ $t('business.list.status.active')}}
            status-component.warningColor(v-else ) {{ $t('business.list.status.inactive')}}

        // Count users (Current/Max)
        td {{ item.countUsers ? item.countUsers : '0' }} / {{ item.maxUsers }}

        // Actions
        td.text-xs-right(class="justify-center px-0 actions")


            // Goals view
            button-component.userList(:action="goalsView" color="primary" icon="track_changes")

            // Users list button
            button-component.goals(:action="usersView" color="primary" icon="people")

            // Send push notification to all members (admin only, requires at least one member)
            button-component.sendPush(
                v-if="isAdmin && hasMembers"
                :action="openPushModal"
                color="primary"
                icon="notifications"
            )

            // Set a starter password for all members without one (admin only)
            button-component.setPassword(
                v-if="isAdmin"
                :action="openPasswordModal"
                color="primary"
                icon="vpn_key"
            )

            // Edit business button
            button-component.edit(:action="edit" color="primary" icon="edit")

            // Delete business button
            button-component.delete(:action="remove" color="primary" icon="delete")

            push-notification-modal(
                v-if="isAdmin && hasMembers"
                v-model="isPushModalOpen"
                :userId="item.id"
                target="business"
            )

            set-password-modal(
                v-if="isAdmin"
                v-model="isPasswordModalOpen"
                :businessId="item.id"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import Status from '~components/Status';
    import PushNotificationModal from '../../Users/List/PushNotificationModal';
    import SetPasswordModal from './SetPasswordModal';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status,
            PushNotificationModal,
            SetPasswordModal
        },
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        },
        data() {
            return {
                isPushModalOpen: false,
                isPasswordModalOpen: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isAdmin']),
            hasMembers() {
                return Number(this.item.countUsers) > 0;
            }
        },
        methods: {
            ...mapActions('businesses', ['deleteAccount']),

            openPushModal() {
                this.isPushModalOpen = true;
            },

            openPasswordModal() {
                this.isPasswordModalOpen = true;
            },
            /**
             * Goals by business
             */
            goalsView() {
                this.$router.push({
                    name: 'dashboard.businesses.goals',
                    params: { id: this.item.id }
                });
            },
            /**
             * Users by business
             */
            usersView() {
                this.$router.push({
                    name: 'dashboard.users.by.business',
                    params: { id: this.item.id }
                });
            },
            /**
             * Edit business
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.businesses.edit',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete business.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount({ id: this.item.id });

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            },

            /**
             * Get title for business program
             * @param item
             * @returns {TranslateResult|VueI18n.TranslateResult|string|{custom: string, challenge: string}|{custom: string, challenge: string}}
             */
            getProgramTitle(item) {
                if (item.programTitle) {
                    return item.programTitle;
                }

                if (item.isCustomProgram) {
                    return this.$t('business.list.programTitle.custom');
                }

                if (item.isChallenge) {
                    return this.$t('business.list.programTitle.challenge');
                }

                return '';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .role
        text-transform: capitalize
</style>
